import React from 'react';

import s from './style.module.css';

class Header extends React.Component {
	render(props) {
		return (
			<div className={`${s.headerWrapper} mt-50`} id="scroll-to-me">
					<div className={'header-3 mb-20'}>See <strong>Booker25</strong> in <strong>action</strong>!</div>
					<p>
						In this call we will discuss the following:
					</p>
					<ul className={s.list}>
						<li>What is Booker25?</li>
						<li>Practical use cases</li>
						<li>How <span className="italic">you</span> can use Booker25</li>
						<li>Booker25 in action - a short product demo</li>
					</ul>
					<p>
						Please schedule your 30 minute appointment below and let us know as much as you can about your requirements. <span className={s.additionalText}> (P.S. You are now using Booker25 &#129299;) </span>
					</p>
					
			</div>
		)
	}
}

export default Header;
